export default __webpack_public_path__ + "28934b7f5bd0a1d590c1ca3ff6c4c3a6.svg";